module.exports = __webpack_public_path__ + "static/media/title.792176bc.svg";